import FilterAltOffRoundedIcon from '@mui/icons-material/FilterAltOffRounded';
import { ActionButton } from '@pages/ActionButton';
import css from './NoResultForFilter.module.scss';

interface NoResultForFilterProps {
  /** Heading. Defaults to a generic "No results found". */
  title?: string;
  /** Sub-text under the heading. */
  description?: string;
  /** When provided, renders a primary "Clear all filters" CTA that calls this. */
  onClearFilters?: () => void;
  /** The CTA's words, for a caller whose filter is a search ("Clear search"). */
  clearLabel?: string;
}

export const NoResultForFilter = ({
  title = 'No results found',
  description = 'Try changing/removing your filter criteria.',
  onClearFilters,
  clearLabel = 'Clear all filters',
}: NoResultForFilterProps) => {
  return (
    <div className={css.noResultForFilter}>
      <FilterAltOffRoundedIcon sx={{ fontSize: 96 }} />
      <span className={css.text}>
        <h1>{title}</h1>
        <span>{description}</span>
      </span>
      {onClearFilters && <ActionButton onClick={onClearFilters}>{clearLabel}</ActionButton>}
    </div>
  );
};
